import React, { createContext, useState, useContext, useEffect } from 'react';
import apis from '@/apis';
import { utils } from '@/utils'
import { useUserInfoStore } from '@/stores'

interface UserContextValue {
  userInfo: any;
  loading: boolean;
}

interface Props {
  children: React.ReactNode;
}

const { to } = utils
const { user: userApi } = apis
// 创建一个用户数据上下文
const UserContext = createContext<UserContextValue>({
  userInfo: null,
  loading: true
});

// 用于获取用户数据的自定义钩子
export const useUserInfo = () => {
  return useContext(UserContext);
};


// 用户上下文提供者组件
// @ts-ignore
const UserProvider = ({ children }: Props) => {
  const [userInfo, setUserInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const userInfoStore = useUserInfoStore()

  useEffect(() => {
    const loadUserData = async () => {
      const [err, res] = await to(userApi.getMyAccountInfo({}))
      if (err) {
        console.log('获取用户数据失败')
        console.error(err)
        return
      }
  
      const { res: resData } = res
      
      userInfoStore.setUserInfo(resData)
      setUserInfo(resData);
      setLoading(false);
    };
  
    loadUserData();
  }, []);

  return (
    <UserContext.Provider value={{ userInfo, loading }}>
      { children }
    </UserContext.Provider>
  );
};

export default UserProvider